'use client';

import dynamic from 'next/dynamic';

const ReviewsVideos = dynamic(() => import('./ReviewsVideos'));

export default ReviewsVideos;
